import React from 'react';

import ModalPpeStdSuccess from './types/ModalPpeStdSuccess';
import ModalPpeTopSuccess from './types/ModalPpeTopSuccess';
import ModalErrorSimple from './types/ModalErrorSimple';
import ModalEstRentaSuccess from './types/ModalEstRentaSuccess';
import ModalSuccessSimple from './types/ModalSuccessSimple';
import ModalRentaSuccess from './types/ModalRentaSuccess';
import ModalFollowAnonymous from './types/ModalFollowAnonymous';
import ModalNetVendors from './types/ModalNetVendors';
import ModalCpf from './types/ModalCpf';
import ModalEmail from './types/ModalEmail';
import ModalPin from './types/ModalPin';
import ModalSuscSuccess from './types/ModalSuscSuccess';
import ModalSuccessDefault from './types/ModalSuccessDefault';
import ModalUnSuscribeConfirm from './types/ModalUnSuscribeConfirm';
import ModalUnSuscribeSuccess from './types/ModalUnSuscribeSuccess';
import ModalConfirmSimple from './types/ModalConfirmSimple';
import ModalEmailIpTelmex from './types/ModalEmailIpTelmex';
import ModalSuscriptionChannel from './types/ModalSuscriptionChannel';
import ModalSocialLevelUp from './types/ModalSocialLevelUp';
import ModalWhatsNew from './types/ModalWhatsNew';
import ModalCannotPlay from './types/ModalCannotPlay';
import ModalNetVendorsRegister from './types/ModalNetVendorsRegister';
import ModalErrorRecording from './types/ModalErrorRecording';
import ModalSuccessResetPassword from './types/ModalSuccessResetPassword.js';
import ModalErrorResetPassword from './types/ModalErrorResetPassword.js';
import ModalTermsAndConditions from './types/ModalTermsAndConditions';
import ModalCompleteInfo from './types/ModalCompleteInfo';
import ModalSuccessSentSMS from './types/ModalSuccessSentSMS';
import ModalRetryPushSession from './types/ModalRetryPushSession';
import ModalIframe from '../../containers/Payment/Gtres/components/ModalGtres';
import NavigationWrapper from './../../components/NavigationWrapper';
import './styles.scss';

const classes = {
  ModalErrorSimple,
  ModalErrorRecording,
  ModalFollowAnonymous,
  ModalNetVendors,
  ModalEmail,
  ModalEstRentaSuccess,
  ModalSuccessSimple,
  ModalRentaSuccess,
  ModalCpf,
  ModalPin,
  ModalSuscSuccess,
  ModalSuccessDefault,
  ModalUnSuscribeConfirm,
  ModalUnSuscribeSuccess,
  ModalConfirmSimple,
  ModalEmailIpTelmex,
  ModalSocialLevelUp,
  ModalSuscriptionChannel,
  ModalWhatsNew,
  ModalCannotPlay,
  ModalNetVendorsRegister,
  ModalSuccessResetPassword,
  ModalErrorResetPassword,
  ModalIframe,
  ModalTermsAndConditions,
  ModalCompleteInfo,
  ModalSuccessSentSMS,
  ModalRetryPushSession,
};

class ModalFactory {
  static create(modal) {
    if (modal == null || modal.modalsVisible.length == 0) {
      return null;
    }

    return modal.modalsVisible.map((modal, index) => {
      const { modalType, props } = modal;
      if (!modalType) {
        throw Error(`Modal parameters error: ${JSON.stringify(modal)}`);
      }

      const finalClassName = `Modal${modalType}`;
      const Component = classes[finalClassName];
      return (
        <NavigationWrapper>
          <Component {...props} />
        </NavigationWrapper>
      );
    });
  }
}

export default ModalFactory;
